import { gql } from "@apollo/client";

export const departmentMasterData = {
  departmentName: "",
  departmentNameStatus: "unchecked",
};

export const departmentDataManage = (state, action) => {
  const inputName = action?.name;
  const value = action?.value;
  switch (inputName) {
    case "departmentName": {
      const alphaNLenghthRegex = new RegExp("^.{1,30}$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          departmentName: value,
          departmentNameStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          departmentName: "",
          departmentNameStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          departmentName: value,
          departmentNameStatus: "error",
        };
      }
    }
    default:
      return state;
  }
};

export const createDepartmentMaster = gql`
  mutation CreateDepartment($input: DepartmentCreateInput!) {
    createDepartment(input: $input) {
      success
      error
      message
      data {
        id
        departmentName
      }
    }
  }
`;

export const getDepartmentById = gql`
  query GetDepartmentById($id: ID!) {
    getDepartmentById(id: $id) {
      success
      error
      message
      data {
        id
        departmentName
      }
    }
  }
`;

export const updateDepartmentMaster = gql`
  mutation UpdateDepartment($input: DepartmentUpdateInput!) {
    updateDepartment(input: $input) {
      success
      error
      message
      data {
        id
        departmentName
      }
    }
  }
`;

export const allDepartments = gql`
  query GetAllDepartments(
    $page: Int
    $pageSize: Int
    $search: String
    $paginate: Boolean
  ) {
    allDepartments(
      page: $page
      pageSize: $pageSize
      search: $search
      paginate: $paginate
    ) {
      success
      error
      message
      totalCount
      totalPages
      currentPage
      hasNextPage
      hasPreviousPage
      data {
        id
        departmentName
      }
    }
  }
`;

export const deleteDepartment = gql`
  mutation DeleteDepartment($departmentId: ID!) {
    deleteDepartment(departmentId: $departmentId) {
      success
      error
      message
      data {
        id
        departmentName
      }
    }
  }
`;
